var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PaymentIndex',{attrs:{"pageTitle":_vm.$t('components.paymentManagement.headline'),"endpoint":_vm.getEndpoint,"fstId":("riderCredits_" + _vm.getId + "_"),"qso":_vm.getEndpointOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }